import { useQuery } from '@tanstack/react-query';

import { defaultStaleTime, queryKeys } from '@/lib/react-query';
import { getSMPBackendAPIAdmin } from '@/proxy';
import { toLocation } from '@/services';

function getLocations() {
  return getSMPBackendAPIAdmin().locationsControllerFindAllV1();
}

export function useLocations() {
  return useQuery({
    queryKey: queryKeys.locations.lists(),
    queryFn: getLocations,
    select: (data) => data.map(toLocation),
    staleTime: defaultStaleTime,
  });
}
